import React from 'react';
import styled from 'styled-components';
import {Eye} from 'components/Ui/Icon';
import {Popover} from 'components/antd';
import ColumnPopover from './ColumnPopover';

export default () => {
  return (
    <PopoverButton
      content={<ColumnPopover />}
      placement="bottom"
      trigger="click">
      <Eye />
      表示項目変更
    </PopoverButton>
  );
};

const PopoverButton = styled(Popover)`
  display: flex;
  cursor: pointer;

  svg {
    height: 17px;
    width: 27px;
  }
`;
